import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import NachReportInternalRemarksUpdateModalUI from './NachReportInternalRemarksUpdateModalUI.js'

class NachReportInternalRemarksUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      internalRemarks: '',
      internalRemarksError: null,
    }
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    const opened = this.props.updateMode && !prevProps.updateMode
    const accountChanged =
      this.props.updateMode &&
      prevProps.selectedAccountId !== this.props.selectedAccountId
    if (opened || accountChanged) {
      this.setState({
        successMsg: null,
        errorList: null,
        submitted: false,
        internalRemarks: '',
        internalRemarksError: null,
      })
    }
  }

  render() {
    return (
      <NachReportInternalRemarksUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        internalRemarks={this.state.internalRemarks}
        onInternalRemarksChange={(event) => {
          this.setState({
            internalRemarks: event.target.value,
            internalRemarksError: null,
          })
        }}
        internalRemarksError={this.state.internalRemarksError}
      />
    )
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  onSubmit = () => {
    if (this.state.submitted || !this.props.selectedAccountId) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    })

    RestApiUtils.put(
      this.props.context,
      `/api/accounts/${this.props.selectedAccountId}/loans/updateNACHInternalRemarks`,
      this.onSubmitCallback,
      { remarks: (this.state.internalRemarks || '').trim() }
    )
  }

  onSubmitCallback = (response) => {
    if (!response) {
      this.setState({
        submitted: false,
        errorList: ['Request failed'],
      })
      return
    }
    const rawErrors = response.errorList || []
    const errorList = rawErrors.map((error) =>
      typeof error === 'string' ? error : error && error.message ? error.message : String(error)
    )

    this.setState({
      successMsg: response && response.success,
      errorList: errorList.length ? errorList : null,
      submitted: false,
    })

    if (rawErrors.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        if (this.props.onRefreshClick) {
          this.props.onRefreshClick()
        }
      }, 1000)
    }
  }
}

export default NachReportInternalRemarksUpdateModalSF
